<div>
    <span *ngIf="isTimeChipPresentAndActive; then chipPresent else noChipPresent"></span>
    <ng-template #noChipPresent>
        <br>
        <b>{{'rm.erp.timemanagement.webtimerecording.error.noChipForUser' | hisUi}}</b>
    </ng-template>
    <ng-template #chipPresent>
        <div *ngIf="isWebTimeRecordLoaded">
            <span *ngIf="webTimeRecord; then webTimeRecordPresent else noWebTimeRecord"></span>
            <ng-template #webTimeRecordPresent>
                <br>
                {{'rm.erp.timemanagement.webtimerecord.label.last.record' | hisUi}}:
                <br><br>
                <b>{{ webTimeRecordTypeLabel }}: {{ webTimeRecord?.timestamp | hisDate: dateTimeFormat }}</b>
                <br><br>
                <span *ngIf="!isDefaultBookingTypeOfficeOrMobileWorking() && !isLastBookingTypeCome()">
                    <ng-container *ngTemplateOutlet="officeMobileWorkingChoice"></ng-container>
                    <br><br>
                </span>
                <ng-container *ngTemplateOutlet="comeButton"></ng-container>
                <ng-container *ngTemplateOutlet="leaveButton"></ng-container>
                <ng-container *ngTemplateOutlet="businessErrandButton"></ng-container>
            </ng-template>

            <ng-template #noWebTimeRecord>
                <br><br>
                <b>{{'rm.erp.timemanagement.webtimerecord.text.no.last.record' | hisUi}}</b>
                <br><br>
                <span *ngIf="!isDefaultBookingTypeOfficeOrMobileWorking() && !isLastBookingTypeCome()">
                    <ng-container *ngTemplateOutlet="officeMobileWorkingChoice"></ng-container>
                    <br><br>
                </span>
                <ng-container *ngTemplateOutlet="comeButton"></ng-container>
            </ng-template>
        </div>
    </ng-template>
</div>

<div>
    <ng-template #comeButton>
        <button (click)="createRecordCome()" hisImage="DOOR_IN" class="button_highlighted green"
            [style]="{'margin-right': '6px'}"
            [disabled]="webTimeRecord && (webTimeRecord.recordType === WEB_TIME_RECORD_TYPE.TERMINAL_COME || webTimeRecord.recordType === WEB_TIME_RECORD_TYPE.MOBILE_WORKING_COME)">
            {{'rm.erp.timemanagement.webtimerecord.button.come' | hisUi}}
        </button>
    </ng-template>

    <ng-template #leaveButton>
        <button (click)="createRecordLeave()" hisImage="DOOR_OUT_ARROW_RED"
            class="button_highlighted red" [style]="{'margin-right': '6px'}"
            [disabled]="webTimeRecord && (webTimeRecord.recordType === WEB_TIME_RECORD_TYPE.TERMINAL_LEAVE || webTimeRecord.recordType === WEB_TIME_RECORD_TYPE.MOBILE_WORKING_LEAVE)">
            {{'rm.erp.timemanagement.webtimerecord.button.leave' | hisUi}}
        </button>
    </ng-template>

    <ng-template #businessErrandButton>
        <button *ngIf="showButtonBusinessErrand" (click)="createRecordBusinessErrand()"
            hisImage="USER_IN_OUT" class="button_highlighted blue">
            {{'rm.erp.timemanagement.webtimerecord.button.businesserrand' | hisUi}}
        </button>
    </ng-template>

    <ng-template #officeMobileWorkingChoice>
        <div class="optionsInline">
            <input type="radio" id="office" name="bookingtype" value="office" [(ngModel)]="selectedBookingType" [disabled]="isLastBookingTypeCome()">
            <label for="office">{{'rm.erp.timemanagement.webtimerecord.radio.office' | hisUi}}</label>
            <input type="radio" id="mobileworking" name="bookingtype" value="mobileworking" [(ngModel)]="selectedBookingType" [disabled]="isLastBookingTypeCome()">
            <label for="mobileworking">{{'rm.erp.timemanagement.webtimerecord.radio.mobileworking' | hisUi}}</label>
        </div>
    </ng-template>
</div>
